import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { wsGetAll } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsFindBy } from 'services/WService';

export default function ModalRule(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [warehouse, setAlmacenes] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }
  async function listAlmacen() {
    let response = await wsGetAll('logi/warehouse?warehouse_type=N');
    if (response.success) setAlmacenes(response.data);
  }
  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);
  
  useEffect(() => {
    if (props.model?.open) {listAlmacen();
      setDataChanging(props.model);
    }
  }, [props.model]);



  return (
    <>
      <Modal
        title={`Actualizar registro`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='purch/purchase-order'
        dataForce={{
          logi_warehouse_id: dataChanging.logi_warehouse_id,
        }}
      >
        <Autocomplete
          disableClearable
          options={warehouse}
          getOptionLabel={(option) => `${option.WhsName}`}
          value={
            warehouse.find(
              (item) =>
                String(item.id) === String(dataChanging.logi_warehouse_id)
            ) || null
          }
          renderInput={(params) => (
            <TextField {...params} label="Almacén" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            handleChange("logi_warehouse_id", item.id);
          }}
          required
        />
      </Modal>
    </>
  );
}
